import { render, staticRenderFns } from "./listDocumentos.vue?vue&type=template&id=4e1cc90d&scoped=true"
import script from "./listDocumentos.ts?vue&type=script&lang=ts&external"
export * from "./listDocumentos.ts?vue&type=script&lang=ts&external"
import style0 from "./listDocumentos.vue?vue&type=style&index=0&id=4e1cc90d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1cc90d",
  null
  
)

export default component.exports